<template>
    <div id="content" class="w">
        <div class="s_tl">
            <span class="left">
                <a href="/">首页</a>
                <code class="lr3">&#62;</code>
                <!-- <a href="javascript:;" @click="catesearch(tableData.pcate,index)">{{tableData.pcate}}</a> -->
                <!-- <code class="lr3">&#62;</code> -->
                <a href="javascript:;">情趣内衣</a>
            </span>
            <div class="right">共找<b class="c3">{{tableData.total}}</b>件</div>
        </div>
        <div class="scat over" style="height: 50px;">
            <dl class="sdl sfst" style="height: 50px;">
                <dt style="height: 50px;"><b class="red">分类</b></dt>
                <dd style="height: 30px;">
                    <div v-for="(cate,index) in cate" :key="index">
                        <router-link :to="{path:'/shop/shopsearch', query:{cate_id:cate.id}}" target="_blank" class="sd_aa f14">
                            {{cate.title}}
                        </router-link>
                    </div>
                </dd>
            </dl>
        </div>
        <div class="sxbox">
            <div class="ls_cat" id="ls_cat">
                <div class="w">
                    <div class="left pl10">
                        <a rel="nofollow" href="javascript:;" class="sb_a " @click="getPrice('综合')" :class="{sb_on:tableFrom.order_sn==''}">综合</a>
                        <a rel="nofollow" href="javascript:;" class="sb_a" @click="getPrice('销量')" :class="{sb_on:tableFrom.order_sn=='invent_sale_desc'}">销量</a>
                        <a rel="nofollow" href="javascript:;" class="sb_a" @click="getPrice" :class="[tableFrom.order_sn=='price_asc' || tableFrom.order_sn=='price_desc'?'sb_on ':'']"><em class="pr10">价格</em><i class="rjg"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <p id="loading" class="lding hid"><em class="lod_ico">加载中,请稍候....</em></p>
        <div class="gdls" id="gdls">
            <dl class="gl" v-for="(item,index) in tableData.data" :key="index"  @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)">
                <dt>
                    <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank">
                        <img :src="item.piclink" width="270" height="270" class="sbm" alt="">
                    </router-link>
                </dt>
                <dd>
                    <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="gna pt10">
                        {{item.title}}
                    </router-link>
                    <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="pt_g mt5">
                        <em class="p_tag">{{item.sub_title}}</em>
                    </router-link>
                </dd>
                <dd class="gp_d">
                    <i class="rmb left">¥</i>
                    <b class="xj left">{{item.price}}</b>
                    <em class="cs_o">已售{{item.invent_sale}}件</em>
                </dd>
                <dd class="pt5">
                    <em class="i_hot">热销</em>
                    <i class="i_by">包邮</i>
                    <i class="i_hot" v-if="item.label">{{item.label}}</i>
                </dd>
            </dl>
        </div>
        <div class="page" id="pager">
            <el-pagination :page-sizes="[20, 40, 60, 80]" :page-size="tableFrom.limit" :current-page="tableFrom.page" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total" @size-change="handleSizeChange" @current-change="pageChange" />
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import Paginations from "@/components/common/paginate.vue"
export default {
    components:{
        "paginations":Paginations
    },
    data(){
        return{
            tableData: {
                data: [],
                total: 0,
            },
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                order_sn: this.$route.query.order_sn ? this.$route.query.order_sn : "",
                // keywords: "",
                page: 1,
                limit: 20,
                type: "1",
                // title: "",
                // sid_cn: "",
                // cate_id: this.$route.query.cate_id ? this.$route.query.cate_id : "",
            },
            isActive:false,
            //数据
            cate:[],
            category:[],
        }
    },
    mounted() {
        this.getList(1);
        // this.getSearchCateProduct(this.$route.query.cate_id);
        this.getLlwjCate();
        // this.getBYTAllProuduct();
    },
    methods:{
        //获取避孕套所有子分类
        getLlwjCate() {
            this.$api.getCategory.getLlwjCate({}).then(res => {
                if (res.code == 200) {
                    this.cate = [];
                    var arr = res.result.soncate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.cate.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取所有子分类热销产品
        getQQNYAllProuduct() {
            this.LogLoading = true;
            this.$api.getShop.getQQNYAllProuduct({}).then(res => {
                if (res.code == 200) {
                    // this.tableData.data = res.result.data;
                    // this.tableData.cate = res.result.cate;
                    // this.tableData.pcate = res.result.pcate;
                    this.tableData.soncate = res.result.soncate;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                }
            });
        },

        //获取所有子分类热销产品
        getSearchCateProduct(cate_id) {
            var that = this;
            var params = {};
            params.cate_id = cate_id || "";
            this.dialogVisible = true;
            this.LogLoading = true;
            that.$api.getShop.getSearchCateProduct(params, this.tableFrom).then(res => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.cate = res.result.cate;
                    this.tableData.pcate = res.result.pcate;
                    this.tableData.soncate = res.result.soncate;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                }
            }).catch((res) => {
                    this.$message.error(res.message);
                    this.listLoading = false;
                });
        },
        // 列表
        getList(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getShop.getQQNYAllProuduct(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                    console.log(this.tableData)
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        getZonghe(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getShop.getQQNYAllProuduct(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                    console.log(this.tableData)
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        getXiaoliang(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getShop.getQQNYXLAllProuduct(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                    console.log(this.tableData)
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        getPrices(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getShop.getQQNYPriceAllProuduct(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                    console.log(this.tableData)
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
            
        },
        getPricesAsc(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getShop.getQQNYPriceAscAllProuduct(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                    console.log(this.tableData)
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
            
        },
        pageChange(page) {
            this.tableFrom.page = page;
            this.getList('');
        },
        handleSizeChange(val) {
            this.tableFrom.limit = val;
            this.getList('');
        },
        //   鼠标移入
        mouseEnter($event){
            $event.currentTarget.className="gl hov";
        },
        //   鼠标移除
        mouseLeave($event){
            $event.currentTarget.className="gl";
        },
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 5){
                this.$router.push(`/biyuntao/`);
            }else if(index == 2){
                this.$router.push(`/zhuxing/`);
            }else if(index == 3){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 4){
                this.$router.push(`/tehui/`);
            }
        },
        getPrice (str) {
            if (str == '综合') {
                this.tableFrom.order_sn = ''
                this.getZonghe();
            } else if (str == '销量') {
                console.log(1111)
                this.tableFrom.order_sn = 'invent_sale_desc'
                this.getXiaoliang();
            } else if (this.tableFrom.order_sn == 'price_asc') {
                console.log(333)
                this.tableFrom.order_sn = 'price_desc'
                this.getPrices();
            } else {
                console.log(444)
                this.tableFrom.order_sn = 'price_asc'
                this.getPricesAsc();
            }
            this.$emit("setSearch", this.tableFrom);
            console.log(this.tableFrom)
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/lingleiwanju/Index.vue